import { FormGroup } from '@angular/forms';
import { ContractRateType, DepositPayment, DepositType, ContractStatus } from "@modules/universal-billing/contract/contract.enums";

function parseGermanDate(s: string): Date | null {
  const parts = s.split('.');
  if (parts.length !== 3) return null;
  const [d, m, y] = parts.map(p => parseInt(p, 10));
  return new Date(y, m - 1, d);
}

function parseNumber(s: string): number | null {
  const m = s.match(/(\d+(\.\d+)?)/);
  return m ? parseFloat(m[1]) : null;
}

export function mapJsonToForm(response: any, form: FormGroup) {
  const r = response.data.result;
  const [addrPart = '', postalPart = ''] = (r.landlordAddress.value || '').split(',');
  const [postalCode = '', ...cityParts] = postalPart.trim().split(' ');
  const street = addrPart.replace(/\d+/, '').trim();
  const houseNumber = (addrPart.match(/\d+/) || [''])[0];

  form.patchValue({
    renter: {
      renterType: null,
      salutationId: null,
      code: null,
      firstName: r.tenants[0]?.name?.value,
      lastName: r.tenants[0]?.surname?.value,
      companyName: null,
      phoneNumber: null,
      email: null,
      bankIban: r.iBANLandlord.value,
      bankAccountHolder: '',
      bankBic: r.bICLandlord.value,
      bankName: null,
      street,
      houseNumber,
      postalCode,
      city: cityParts.join(' '),
    },
    rentalDetails: {
      rentType: null,
      startDate: parseGermanDate(r.startOfRental.value),
      endDate: null,
      permanent: r.rentalPeriod.value === 'unbestimmte Zeit',
      residentsQuantity: null,
      apartmentId: null,
      buildingId: null
    },
    payment: {
      unitType: ContractRateType.FlatRateRent,
      flatRate: parseNumber(r.rent.value),
      coldRent: parseNumber(r.additionalCostsAdditionalUtilities.value),
      totalPrepayment: null,
      operatingCost: parseNumber(r.additionalCostsAdditionalUtilities.value),
      heatingCost: parseNumber(r['additionalCostsHeating/hotWater'].value),
      validFrom: {value: null, disabled: true}
    },
    sideCosts: [],
    deposit: (() => {
      const depositType = r.depositPaymentMethod.value.includes('Bankbürgschaft')
        ? DepositType.BANK_GUARANTEE
        : r.depositPaymentMethod.value.includes('Sparbuch')
          ? DepositType.PLEDGED_SAVINGS_ACCOUNT
          : DepositType.NO_DEPOSIT;
      const depositPayment = depositType === DepositType.NO_DEPOSIT
        ? DepositPayment.NOT_SELECTED
        : r.depositPaymentMethod.value.includes('in 3 Raten')
          ? DepositPayment.PAYMENT_IN_3_MONTHS
          : DepositPayment.ONE_TIME_PAYMENT;
      return {
        depositType,
        depositAmount: parseNumber(r.depositAmount.value),
        depositDueDate: null,
        depositPayment
      };
    })(),
    notes: '',
    status: ContractStatus.ACTIVE,
    billingPeriod: null
  });
}
